var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      on: {
        click: function($event) {
          return _vm.fnClick(_vm.data.text)
        },
        mouseover: function($event) {
          return _vm.fnHoverMessage(_vm.data.text)
        },
        mouseleave: _vm.fnClearHoverMessage
      }
    },
    [
      _c("el-tag", { staticClass: "tag-green" }, [
        _vm._v(_vm._s(_vm.data.textShow))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06475dae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06475dae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MassageSuggest.vue
// module id = null
// module chunks = 